import axios from 'axios'
// import qs from 'qs'
export const ruleActionService = ({
  getAllRules (token, elementId) {
    return axios.get('/api/RuleMaster/GetElementRules?elementId=' + elementId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllAction (token) {
    return axios.get('/api/ActionMaster/GetActions', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllPersonalizationStep (token, courseMasterId, elementRuleActionMasterId, returnAllLesson = false) {
    return axios.get('/api/PersonalizationElement/GetAll?courseMasterId=' + courseMasterId + '&ElementRuleActionMasterId=' + elementRuleActionMasterId + '&returnAllLesson=' + returnAllLesson, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createRuleAction (token, objToPost) {
    return axios.post('/api/ElementRuleActionMaster/CreateSingle', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getExistingRulesAndAction (token, elementId) {
    return axios.get('/api/ElementRuleActionMaster/GetAll?elementId=' + elementId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllExistingRulesAndAction (token) {
    return axios.get('/api/ElementRuleActionMaster/GetAll', {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteExistingRulesAction (token, elementRuleActionId) {
    return axios.delete('/api/ElementRuleActionMaster/delete?elementRuleActionId=' + elementRuleActionId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateExistingRuleAction (token, objToPost) {
    // var stringifiedObj = qs.stringify(topicObj)
    return axios.put('/api/ElementRuleActionMaster/Put', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/rule-action-service.js